/** Katalog kode izin BE (lihat readme-BE.md "Katalog permission"). */
export const PERMISSIONS = {
  tenantView: 'tenant.view',
  tenantManage: 'tenant.manage',
  outletView: 'outlet.view',
  outletManage: 'outlet.manage',
  productView: 'product.view',
  productManage: 'product.manage',
  priceTypeView: 'price_type.view',
  priceTypeManage: 'price_type.manage',
  transactionCreate: 'transaction.create',
  transactionView: 'transaction.view',
  transactionVoid: 'transaction.void',
  transactionCompliment: 'transaction.compliment',
  transactionMerge: 'transaction.merge',
  transactionSplit: 'transaction.split',
  transactionKitchen: 'transaction.kitchen',
  /** Master metode pembayaran — bukan penerimaan uangnya (payment.receive). */
  paymentView: 'payment.view',
  paymentManage: 'payment.manage',
  /**
   * Menerima uang atas satu transaksi. Dipegang kasir bersama
   * `transaction.create`; dipisah dari `paymentManage` supaya kasir tidak perlu
   * hak menambah/menghapus metode bayar hanya untuk bisa menutup tagihan.
   */
  paymentReceive: 'payment.receive',
  discountView: 'discount.view',
  discountManage: 'discount.manage',
  inventoryView: 'inventory.view',
  inventoryManage: 'inventory.manage',
  stockAdjust: 'stock.adjust',
  stockIn: 'stock.in',
  stockTransfer: 'stock.transfer',
  reportView: 'report.view',
  reportTransactionView: 'report.transaction.view',
  reportTransactionEdit: 'report.transaction.edit',
  reportCentralKitchenView: 'report.central_kitchen.view',
  userView: 'user.view',
  userManage: 'user.manage',
  roleView: 'role.view',
  roleManage: 'role.manage',
  /** Modul Printer */
  printerView: 'printer.view',
  printerManage: 'printer.manage',
  /** Modul Layout Meja */
  tableView: 'table.view',
  tableManage: 'table.manage',
  /** Modul Cashier Sessions & Expenses */
  cashierOpenClose: 'cashier.open_close',
  cashierExpense: 'cashier.expense',
  cashierReport: 'cashier.report',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
